import styled from 'styled-components';

export default styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  margin-top: ${({ $top }) => ($top ? `${$top}px` : '0px')};
  padding: ${({ $padding }) => ($padding ? `${$padding}px` : '0px')};
  border: 0;
  z-index: 0;

  h4 {
    margin-bottom: -2px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${({ $radius }) => ($radius ? `${$radius}px` : '0px')};
    background: ${({ theme }) => theme.colors.gradient.fullX};
    opacity: ${({ $active }) => ($active ? `1` : '0.3')};
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${({ $radius }) => ($radius ? `${$radius}px` : '0px')};
    padding: 2px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &[disabled] {
    transition: 0.7s;
    opacity: 0.5;
    cursor: default;
  }

  &:hover {
    &[disabled] {
      &::before {
        opacity: 0.3;
      }
    }

    &::before {
      transition: 0.7s;
      opacity: 1;
    }
  }
`;
